import GeneralInfo from "./GeneralInfo";
import PermissionRelease from "./PermissionRelease";
import OtherInfo from "./OtherInfo";
import Pricing from "./Pricing";
import Confirmation from "./Confirmation";

const STEP_COMPONENTS = {
  1: GeneralInfo,
  2: PermissionRelease,
  3: OtherInfo,
  4: Pricing,
  5: Confirmation,
};

export function getStepComponent(stepId) {
  return STEP_COMPONENTS[stepId] || null;
}
